
export default [
    {date: "12/11",
    description: "Desmistificando recursos do Android",
    place: "Aud. III",speaker: "-",time: "19:00 22:00",},

    {date: "13/11",
    description: "Oficinas e Hackaday",
    place: "PROA II",
    speaker: "-",
    time: "19:00 22:00",},
    
    {date: "14/11",
    description: "Apresentação dos pitchs",
    place: "Aud. III",
    speaker: "-",
    time: "19:00 22:00",},
]
